import styled from '../../../styles/styledComponents/themeComponents';

export const PageHeaderStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const IconList = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
